module.exports = __webpack_public_path__ + "img/HIGH-5.e616a3f8.png";